import {PrintEmployees} from './../../dphs/hr/employeeSlice'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const ListStaff = createAsyncThunk('staff-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}staff/list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createStaff = createAsyncThunk('staff-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}staff/store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editStaff = createAsyncThunk('staff-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}staff/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const viewStaff = createAsyncThunk('staff-view', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}staff/view/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createEducation = createAsyncThunk('educations-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}staff/create/education`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const editEducation = createAsyncThunk(
  'staff-edit-education',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}staff/edit/education/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const viewEducations = createAsyncThunk('educations-view', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}staff/view/educations/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createExperience = createAsyncThunk(
  'experience-create',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}staff/create/experience`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const editExperience = createAsyncThunk('edit-experience', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}staff/edit/experience/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const viewExperiences = createAsyncThunk(
  'experiences-view',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}staff/view/experiences/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createContract = createAsyncThunk('contract-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}staff/create/contract`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const editContract = createAsyncThunk('edit-contract', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}staff/edit/contract/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const viewContracts = createAsyncThunk('contracts-view', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}staff/view/contracts/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetEmployeeList = createAsyncThunk('get-staff-list', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}staff/get/list`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const endContract = createAsyncThunk('contract-end', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}staff/end/contract`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const staffContractPrint = createAsyncThunk(
  'staff-contract-print',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}staff/print-contract/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const GetLecturerListAccount = createAsyncThunk(
  'get-lecturer-list-for-account',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}staff/get/lecturer/list/account`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetEmployeeListAccount = createAsyncThunk(
  'get-staff-list-for-account',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}staff/get/staff/list/account`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createUserAccount = createAsyncThunk(
  'create-user-account',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}staff/user/account`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const printStaffIdCard = createAsyncThunk(
  'staff-print-card',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}staff/print-card/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStaffAccountDetails = createAsyncThunk(
  'account-details',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}staff/account-details/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStaffRelatedItemsClearance = createAsyncThunk(
  'related-items-clearance',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}staff/related-items-clearance/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const moveItemToStock = createAsyncThunk(
  'move-items-to_stock',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}staff/move-items-to_stock/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PrintStaff = createAsyncThunk('print-staff', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}staff/print-staff`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StaffExcel = createAsyncThunk('staff-excel', async (params: {}) => {
  const response = await axios.get(`${api}staff/excel-staff`, {
    params,
    responseType: 'blob',
  })

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = 'Staff List.xlsx'
  document.body.appendChild(link)
  link.click()

  link.remove()
  window.URL.revokeObjectURL(url)
})

type staffState = {
  errors: any
}

const initialState: staffState = {
  errors: '',
}

export const staffSlice = createSlice({
  name: 'staff',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createStaff.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(createEducation.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(createExperience.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(createContract.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(createUserAccount.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = staffSlice.actions
export default staffSlice.reducer
